<template>
<div class="lesson" :style="{paddingTop: headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true"></SubHeader>
  <div class="box-line" id="line"></div>
  <van-list v-loading="listLoading" v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了">
    <div class="list">
      <PriceCard v-for="item of list" :key="item.id" :cardData="item" @click.native="jumpDetail(item)"></PriceCard>
    </div>
  </van-list>
  <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeader";
import LiveCard from "@/components/LiveCard";

export default {
  name: "lesson",
  components: {
    PriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    LiveCard,
  },
  data() {
    return {
      active: 0,
      list: [],
      tag: 1,
      classify: 0,
      certificate: [],
      category: [],
      loading: false,
      pageLoading: true,
      finished: true,
      more: false,
      listLoading: false
    };
  },
  async mounted() {
    window.addEventListener("scroll", this.onLoad);
    this.getData();
  },
  destroyed() {
    window.removeEventListener("scroll", this.onLoad);
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    getTag(index) {
      this.tag = index;
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/platform/pc/category",
        data: {
          flat_id: this.plat,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.list = res.data.zi_list;
      } else {
        this.$toast(res.msg);
      }
    },
    jumpDetail(item) {
      this.$router.push(`./detail?id=${item.id}`);
    },
    getMore() {
      if (this.more) {
        return;
      }
      this.more = true;
      if (this.menu == 2) {
        axios
          .get(
            `/api/platform/pc/category?flat_id=${this.plat}&page=${this.page}`, {}
          )
          .then((res) => {
            this.more = false;
            console.log(res);
            if (res.code == 0) {
              let list = res.data.category[this.classify].goods;
              this.list = this.list.concat(list);
              this.loading = false;
              if (list.length < 10) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.more = false;
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    // console.log(to);
    next();
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;

  .van-sticky {
    left: auto;
    right: auto;
  }

  .list {
    margin-top: 30px;
  }
}
</style>

<style lang="scss">
</style>
